<div [id]="((isActive())? card().ident : null)" class="card bg-base-100 shadow-sm">
  <figure>
		<a [routerLink]="getUrl()" [queryParams]="getQueryParams()">
			<img class="card-img" hSkeleton="200px" [src]="binderS.getImgCard(card(), scan())" [attr.loading]="((lazy())? 'lazy' : null)"/>
		</a>
		@if(!isActive()){
			<div class="progress-component">
				<lgb-progress></lgb-progress>
			</div>
		}
		@else if(!infos()){
			<div class="price-over-card badge badge-soft px-2">
				@if(card().amount){
					@if(card().price){
		    		<img [src]="market() | imgMarketPlace"/>
		    	}
		  		{{card().amount | number:'1.2-2':'fr-FR'}}€
		  	}
		  	@else{
		  		NC
		  	}
	  	</div>
		}
  </figure>
	@if(isActive()){
	  <div class="card-body">
	  	@if(infos()){
	    	<p>
	    		{{name().text}} <span class="text-xs opacity-60 tracking-wide">(# {{reference().numero}})</span>
	    	</p>
	    	<p>
	    		<span class="img-lang badge badge-soft badge-primary">
	    			<img src="img/skin/flag-{{card().lang}}.svg"/>
	    		</span>
					<span class="text-xs tracking-wide condition">
		    		{{card().lang | uppercase}}
		    	</span>
	    	</p>
	    	<p class="mb-1">
	    		<lgb-rate [rate]="getCondition().ref | valCondition"></lgb-rate>
					<span class="text-xs tracking-wide condition">
		    		{{getCondition().name}}
		    	</span>
	    	</p>
	    	<p class="mb-2">
	    			@if(card().price){
		    			<img class="icon-market mr-2" [src]="market() | imgMarketPlace"/>
		    		}
		    		@else{
		    			<span class="img-lang badge badge-soft badge-primary">
								<i class="badge-primary fa-regular fa-piggy-bank"></i>
			    		</span>
		    		}
					<span class="text-xs tracking-wide condition">
						@if(card().amount){
	  					{{card().amount | number:'1.2-2':'fr-FR'}}€
	  				}
	  				@else{
	  					NC
	  				}
		    	</span>
	    	</p>
	    }
	    @else{
	    	<div class="no-info">
	    		<span class="img-lang badge badge-soft badge-primary">
	    			<img src="img/skin/flag-{{card().lang}}.svg"/>
	    		</span>
	    		<lgb-rate [rate]="getCondition().ref | valCondition"></lgb-rate>
	    	</div>
	    }
	    @if(admin()){
		    <div class="card-actions">
		   		<a href="#" [routerLink]="router.parse('collect-card', [card().ident])" [queryParams]="getQueryParams()" class="btn text-primary">
		   			<i class="fa-sharp fa-solid fa-list-ul"></i>
			    </a>
			    <lgb-share [element]="card()" typeElement="card">
			   		<span class="btn text-primary">
			   			<i class="fa-light fa-paper-plane"></i>
				    </span>
				  </lgb-share>
		   		<a (click)="toggleFavoriteCard()" class="btn text-primary">
		   			<i [ngClass]="{'fa-solid': card()?.isFavorite, 'fa-light': !card()?.isFavorite}" class="fa-light fa-bookmark"></i>
			    </a>
		    </div>
		  }
	  </div>
	}
</div>